import clsx from "clsx";
import tear from "@/assets/brand/paper-tear.webp";

// The Figma separates its full-bleed bands with a strip of torn paper rather
// than a rule. The asset is white paper on transparency, so the same image
// serves both edges: flipped, the tear points the other way.
export default function PaperTear({
  flip = false,
  className,
}: {
  flip?: boolean;
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={clsx(
        "pointer-events-none -mt-px h-14 w-full sm:h-24",
        flip && "scale-y-[-1]",
        className,
      )}
      // The asset is the paper's lower torn edge: sheet at the top, rip, then
      // clear. Sitting at the head of a band, the sheet lines up with the
      // section above and the rip exposes the band. Stretched rather than
      // tiled, because repeating puts a visible seam mid-rip.
      style={{
        backgroundImage: `url(${tear})`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    />
  );
}
